import React from "react";
import { Avatar, Heading, HStack, Image, Link, Stack, Text } from "@chakra-ui/react";

const Vancouver = () => {
  return (
    <Stack
      bg="#ebe8f1cc"
      padding="32px"
      fontFamily="Garamond"
      fontSize="xl"
      marginTop="8px"
      alignItems="flex-start"
      spacing={3}
      backgroundImage="/vancouver.jpg"
      backgroundSize="cover"
      backgroundPosition="center center"
      backgroundBlendMode="lighten"
    >
      <Stack
        backgroundColor="rgba(255,255,255,0.5)"
        padding="16px"
        alignItems="center"
        spacing={4}
      >
        <Stack direction={{ base: "column", lg: "row" }} alignItems="center">
          <Stack>
            <Heading as="h2" size="xl">
              Metro Vancouver
            </Heading>
            <Text>
              Vancouver is arguably the most stunning city in Canada, offering a rare balance of urban energy and breathtaking natural landscapes. 
              It’s a place where you can find mountains, oceans, and lush forests right at your doorstep. While the "West Coast lifestyle" is incredible, it’s important to note that—like most major global hubs—the cost of living here is higher than in smaller Canadian cities. 
              However, the trade-off is a vibrant, inclusive community with an abundance of support systems designed to help you succeed.
              If you are arriving as a Permanent Resident, there are numerous specialized resources available to ensure your transition into Canadian society is as smooth as possible.
            </Text>
            <Text>Here are some resources to check out:</Text>
          </Stack>
          <Image
            src="/vancouver2.jpg"
            alt="Vancouver picture"
            w="450px"
            flex="1"
            display={{ base: "none", lg: "inherit" }}
          />
        </Stack>
        <HStack justifyContent="center" w="100%">
          <Avatar
            as="a"
            name="INS"
            size="2xl"
            src="/impactns.jpeg"
            href="https://impactnorthshore.ca/"
            target="_blank"
          />
          <Avatar
            as="a"
            name="ISSBC"
            size="2xl"
            src="/issbc.png"
            href="https://issbc.org/"
            target="_blank"
          />
          <Avatar
            as="a"
            name="ISSBC"
            size="2xl"
            src="/newbc.png"
            href="https://newtobc.ca/"
            target="_blank"
          />
        </HStack>
        <Text alignSelf="flex-start">
          Looking to do something fun? Visit{" "}
          <Link color="teal" href="https://604now.com/" isExternal>
            604now
          </Link>
          !
        </Text>

        <Image
          src="/vancouver2.jpg"
          alt="Vancouver picture"
          w="100%"
          flex="1"
          display={{ base: "inherit", lg: "none" }}
        />
      </Stack>
    </Stack>
  );
};

export default Vancouver;
